



































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { BrandingInfo } from '@/models/branding/branding';
declare var window: any;

@Component
export default class Footer extends Vue {
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }
  get appName() {
    return vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
    );
  }
  get dynamicPrivacyPolicyText(){
    return vxm.configs.getGlobalConfigValue('DYNAMIC_PRIVACY_POLICY_TEXT') || this.$t('help.privacypolicy');
  }
  get companyURL() {
    return vxm.configs.getGlobalConfigValue(
      'CANDIDATE_PORTAL_COMPANY_LOGO_REDIRECTION_LINK',
    );
  }
  isRedirection(): boolean {
    if (
      vxm.configs.getGlobalConfigValue(
        'CANDIDATE_PORTAL_COMPANY_LOGO_REDIRECTION_LINK',
      ).length == 0
    ) {
      return false;
    }
    return true;
  }
}
